/*
 * Page Name
 */

jQuery(document).ready(function () {

    // your code here

});